// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		if(document.getElementById('header').classList.contains('no-hero') || document.getElementById('gallery') || document.getElementById('attractions')){
			document.getElementById('header').classList.add('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
		} else{
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}
		convertBtn(['btn', 'attractions-map__expand'], '.signup-btn');

	};

	function convertBtn(classList, excludeElementSelector) {
		if (classList.length > 0) {
			classList.forEach((className) => {
			let elements = document.querySelectorAll('.' + className);
			elements.forEach((btn) => {
				// Verificar si el elemento actual no coincide con el selector de exclusión
				if (!btn.matches(excludeElementSelector)) {
				let INNER_TEXT = btn.innerHTML;
				btn.innerHTML = '<span>' + INNER_TEXT + '</span> <div class="wave"></div>';
				}
			});
			});
		}
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	
	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// BURGER MENU NAVIGATION:

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');

		menuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.add('open');
		});

		closeMenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.remove('open');
		});

	// BURGUER MENU MOBILE ----------------------------------------------------------------

	const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
	const burgerMenuContainer = document.querySelector("#js-menuContainer")
	const closeMenu = document.querySelector(".js-burger-close");
	
	//Open Menu

	if(burgerMenuBtn){
		burgerMenuBtn.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenuContainer.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	}
	
	if(closeMenu){
		closeMenu.addEventListener('click', () => {
			burgerMenuContainer.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});
	}

	// SHOW SUBMENU FUNCTION: 

	const submenuToShow = (linksSelector, linkSubmenu) => {
		let navLinks = document.querySelectorAll(linksSelector); 
		let submenu_active = document.querySelectorAll(linkSubmenu); 

		navLinks.forEach(link => {
			const parent = link.parentNode;
			let submenu = parent.querySelector('.submenu');
			link.addEventListener('click', (e) => {
				link.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
		submenu_active.forEach(sub => {
			if (sub.classList.contains('active')) {
				if (window.screen.width > 640) {
					let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}else{
					let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}
			}

		})
	}

	if (window.screen.width > 640) {
		submenuToShow('#primary-nav li a', '.submenu li a');
	} else {
		submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
	}

	document.addEventListener('DOMContentLoaded', function() {
		const leftTitles = document.querySelectorAll('.accordion-rooms__left .item');
		const rightTitles = document.querySelectorAll('.accordion-rooms__right .js-accordion-rooms-title');
		const rightItem = document.querySelectorAll('.accordion-rooms__right .item');

		if(rightItem[0]){
			rightItem[0].classList.add('active');
		}
	

		function removeActiveClassFromRightTitles() {
			if (rightTitles.length > 0) {
				rightTitles.forEach(function(rightTitle) {
					rightTitle.classList.remove('active');
				});
			}
		}

		function setActiveToFirstRightTitle() {
			if (rightTitles.length > 0) {
				rightTitles[0].classList.add('active');
			}
		}

		function setActiveToFirstLeftTitle() {
			if (leftTitles.length > 0) {
				leftTitles[0].classList.add('active');
			}
		}

		function addActiveToClosestItem(element) {
			if (element) {
				const clickedItem = element.closest('.item');
				if (clickedItem) {
					const siblings = clickedItem.parentNode.querySelectorAll('.item');
					siblings.forEach(function(sibling) {
						if (sibling !== clickedItem) {
							sibling.classList.remove('active');
						}
					});
					clickedItem.classList.toggle('active');
				}
			}
		}

		setActiveToFirstRightTitle();
		setActiveToFirstLeftTitle();

		rightTitles.forEach(function(rightTitle, index) {
			rightTitle.addEventListener('click', function() {
				removeActiveClassFromRightTitles();

				const clickedIndex = index;

				rightTitle.classList.add('active');

				if (leftTitles.length > 0) {
					leftTitles.forEach(function(leftTitle) {
						leftTitle.classList.remove('active');
					});

					if (leftTitles[clickedIndex]) {
						leftTitles[clickedIndex].classList.add('active');
					}
				}

				addActiveToClosestItem(rightTitle);
			});
		});

	});

	// FILTER TABS ----------------------------------------------------------
	
	let links = document.querySelectorAll('.tab-js');
	let contents = document.querySelectorAll('.tab-content-js');

    console.log(contents);

	if(links.length != 0 && contents.length != 0){
		links[0].classList.add('active');
		contents[0].classList.add('active');
	}

	links.forEach((link) => {
		link.addEventListener('click', () => {
			links.forEach((allLinks) => {
				allLinks.classList.remove('active');
			});
			link.classList.add('active');
			contents.forEach((content) => {
				let linkTag = link.getAttribute('data-tag');
				let contentTag = content.getAttribute('data-tag');
				content.classList.remove('active');
				if (linkTag === contentTag) {
					content.classList.add('active');
				}
			});
		});
	});

	

	// PARALLAX ANIMATION *****************************************************/

	const scrollParallax = {};

	const v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	function doParallax(elm) {
	let bounds = elm.dataset.parallax.split(",").map(Number);
	let distance = bounds[1] - bounds[0];
	let unit_scroll = distance / (v_height + elm.offsetHeight);

	let topElement = elm.getBoundingClientRect().top + window.pageYOffset;

	let beforeSpeed = parseFloat(elm.dataset.parallaxSpeedBefore) || 1.0;
	let afterSpeed = parseFloat(elm.dataset.parallaxSpeedAfter) || 1.0;

	let parallaxFunction = function () {
		let scrolled = window.pageYOffset;
		let relative_distance = scrolled + v_height - topElement;
		let temp = unit_scroll * relative_distance + bounds[0];

		elm.style.transform = `translate(0, ${temp}px)`;
	};

	scrollParallax[elm.dataset.parallaxid] = parallaxFunction;

	window.addEventListener('scroll', scrollParallax[elm.dataset.parallaxid]);
	}

	let observers_parallax_elements = document.querySelectorAll(".js-parallax-element");
	observers_parallax_elements.forEach((elm) => {
	doParallax(elm);
	});

	const options_parallax = {
	root: null,
	rootMargin: '0px',
	threshold: 0,
	};

	function handler_parallax(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			const id_elem = target.dataset.parallaxid;

			if (entry.isIntersecting) {
			doParallax(target);
			} else {
			window.removeEventListener('scroll', scrollParallax[id_elem]);
			}
		});
	}

	const observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
	let counter = 1;

	observers_parallax_elements.forEach((element) => {
	observable_parallax.observe(element);
	element.dataset.parallaxid = counter;
	counter++;
	});


})();




function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 60){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// Login Function ----------------------------------------------------------------


function loginMembers(e){
	e.preventDefault();
    let extras = {}, 
        formId = "loginForm",
        url = "/ajax/functions.php",
        formData = new FormData(document.getElementById(formId));

    formData.append('operation', 'loginMembers');
    formData.append('site_id',site_id);
	
	clearErrors(formId);
	formProcessSetup(formId);
    const divLoginForm = document.querySelector(`#${formId}`);
    fetch(url, {
        method: 'POST',
        body: formData
    }).then(response => response.json())
        .then(data => {
        divLoginForm.classList.remove('hidden');
        if (data.result === 'success') {
			localStorage.setItem( "username", data.username );
			localStorage.setItem( "session_start", 1 );
			document.location = "/ownership-portal";
			// showResult(data, formId, extras);
        } else {
            showErrors(data, formId, extras);
        }
    }).catch(error => {
        console.error('Error:', error)
        divLoginForm.classList.remove('hidden');    
    });
}


function clearErrors(formId) {
    // Remover la clase "error" de los elementos input, textarea, y select
    var elements = document.querySelectorAll(`#${formId} input[type="text"], #${formId} input[type="password"],#${formId} input[type="checkbox"],#${formId} input[type="radio"],#${formId} input[type="number"],#${formId} textarea,#${formId} select`);
    elements.forEach(function(element) {
        element.classList.remove('error');
    });

    // Remover la clase "error" de los labels que no tienen la clase "errorMsg"
    var labels = document.querySelectorAll('#' + formId + ' label');
    labels.forEach(function(label) {
        if (!label.classList.contains('errorMsg') && label.classList.contains('error')) {
            label.remove();
        }
    });

    // Remover los spans que tienen las clases "msg" y "error"
    var spans = document.querySelectorAll('#' + formId + ' span');
    spans.forEach(function(span) {
        if (span.classList.contains('msg') && span.classList.contains('error')) {
            span.remove();
        }
    });
}

function formProcessSetup(formId) {
    // Seleccionar todos los elementos con la clase "errorMsg" dentro del formulario y ocultarlos
    var errorMsgs = document.querySelectorAll('#' + formId + ' .errorMsg');
    errorMsgs.forEach(function(errorMsg) {
        errorMsg.style.display = 'none';
        errorMsg.innerHTML = '';
    });

    // Mostrar elementos con la clase "processing" si existen dentro del formulario
    var processingElements = document.querySelectorAll('#' + formId + ' .processing');
    if (processingElements.length > 0) {
        processingElements.forEach(function(element) {
            element.style.display = 'block';
        });
    }
}

function showResult(data, formId, extras) {
    
    var errorMsgs = document.querySelectorAll('#' + formId + ' .errorMsg');
    errorMsgs.forEach(function(errorMsg) {
        errorMsg.style.display = 'none';
        errorMsg.innerHTML = '';
    });
    var result; //will hold the value for our result success | error

    if (data[0] == undefined) result = data.result;
    else result = data[0].result;
    if (result == "success") {
        if (extras.dont_reset_form != '1') { resetForm(formId); }

        let thankyouMessage = document.querySelector('.thankyouMsg');
        if(thankyouMessage) {
            thankyouMessage.classList.remove('hidden');
            thankyouMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="670" height="133.21" viewBox="0 0 670 133.21"><path d="M518.76,130.97v-.37c-11.58-5.13-14.92-9.38-14.92-17.3V19.86c0-7.92,3.29-12.13,14.92-17.3v-.37h-59.08v.37c11.58,5.13,14.92,9.38,14.92,17.3v93.45c0,7.92-3.29,12.13-14.92,17.3v.37h59.08Z" style="stroke-width: 0px;"/><path d="M612.57,2.2h-46.17v.37c13.04,4.76,15.1,10.85,11.58,19.86l-31.26,82.42c-5.72,14.92-10.48,20.59-18.95,25.76v.37h40.32v-.37c-16.93-4.99-20.96-16.75-16.93-27.59l5.72-15.28h56.65l8.1,21.14c4.26,11.03,1.28,15.42-14.92,21.69v.37h63.29v-.37c-9.38-6.04-12.72-9.93-16.2-18.76L612.57,2.2ZM584.79,12.31l27.59,72.49h-54.46s26.86-72.49,26.86-72.49Z" style="stroke-width: 0px;"/><path d="M374.33,74.73l-25.35-45.17c-9.02-16.7-.73-23.84,16.15-27.55h-77.11c14.14,3.66,21.1,11.03,31.21,27.55l56.74,100.95c6.22-11.58,13.77-27.73-1.65-55.83v.05ZM444.62,2.06h-55.1c16.52,5.49,22.01,11.03,27.55,27.55,5.49-16.52,11.03-22.06,27.55-27.55Z" style="stroke-width: 0px;"/><path d="M68.46,133.21c39.4,0,68.28-22.84,68.28-66.58S107.82,0,68.46,0,0,22.79,0,66.58s28.88,66.58,68.46,66.58v.05ZM68.46,129.87c-22.42,0-36.24-21.51-36.24-63.29S45.99,3.29,68.46,3.29s36.24,21.51,36.24,63.29-14,63.29-36.24,63.29Z" style="stroke-width: 0px;"/><path d="M235.67,2.56c17.3,6.27,24.3,13.96,24.3,27.59v53.18L191.88,2.2h-42.88v.37c11.58,5.13,14.92,9.38,14.92,17.3v82.97c0,12.86-4.39,22.61-14.92,27.78v.37h42.51v-.37c-17.48-6.27-24.3-13.96-24.3-27.41V18.21l96.24,113.9V30.34c0-12.86,4.26-22.61,14.92-27.78v-.37h-42.7v.37Z" style="stroke-width: 0px;"/></svg><br>Your registration request has been received.</br>Thank you for your interest in ONVIA.</span>';
        }

        let form = document.getElementById(formId);
        if(form)
            form.classList.add('hidden');
    }else{
        showErrors(data, formId, extras);
    }
}

function showErrors(data, formId, extras) {
    clearErrors(formId);

    var newData = {};
    if (data[0] === undefined) newData = data;
    else newData = data[0];

    // Recorre el array JSON y muestra los errores
    for (var key in newData) {
        if (newData.hasOwnProperty(key) && !String(key).includes('result','errorMsg')) {
            var element = document.querySelector(`#${formId} #${key}`);
            var label = document.querySelector(`#${formId} label[for=${key}]`);
            
            if (label) label.classList.add("error");
            if (element) element.classList.add("error");
            var errorLabel = document.createElement('label');
            errorLabel.id = key + '-error';
            errorLabel.className = 'msg error';
            
            if(newData[key]== 1)
                errorLabel.innerText = 'This field is required.';
            else
                errorLabel.innerText = newData[key];

            
            if (label && label.insertAdjacentElement !== undefined ) {
                label.insertAdjacentElement('afterend', errorLabel);
            } else if (element && element.insertAdjacentElement !== undefined) {
                element.insertAdjacentElement('afterend', errorLabel);
            }
        }
    }

    var errorMsgElement = document.querySelector("#" + formId + " .errorMsg");
    
    if (errorMsgElement.innerHTML === "") {
        if (newData.errorLogin !== undefined && formId === 'loginForm') {
            errorMsgElement.innerHTML = "<ul><li>" + newData.errorLogin + "</li></ul>";
            document.getElementById('username').classList.add('error');
            document.getElementById('password').classList.add('error');
        } else if (newData.errorActiveAccount !== undefined && formId === 'activeForm') {
            errorMsgElement.innerHTML = "<ul><li>" + newData.errorActiveAccount + "</li></ul>";
            var confirmPasswordError = document.getElementById('confirm_password-error');
            if (confirmPasswordError) confirmPasswordError.remove();
        } else if (newData.errorProcessRecovery !== undefined && formId === 'forgotForm') {
            errorMsgElement.innerHTML = "<ul><li>" + newData.errorProcessRecovery + "</li></ul>";
            if (document.getElementById('email_forgot').value !== '') {
                var emailForgotError = document.getElementById('email_forgot-error');
                if (emailForgotError) emailForgotError.remove();
            }
        } else if (newData.errorRegisterForm !== undefined && formId === 'registerForm') {
            errorMsgElement.innerHTML = "<ul><li>" + newData.errorRegisterForm + "</li></ul>";
        } else if (formId !== 'loginForm' && formId !== 'activeForm' && formId !== 'forgotForm') {
            errorMsgElement.innerHTML = "<ul><li>Please correct the errors highlighted in red above.</li></ul>";
        }
    } else {
        errorMsgElement.innerHTML = "<ul>" + errorMsgElement.innerHTML + "</ul>";
    }

    errorMsgElement.style.display = 'block'; // Similar a slideDown en jQuery

    if (extras.dont_scroll_on_error !== '1') {
        if (extras.scrollto !== undefined) {
            var scrollToElement = document.getElementById(extras.scrollto);
            if (scrollToElement) {
                scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    var processingElements = document.querySelectorAll('#' + formId + ' .processing');
    processingElements.forEach(function(element) {
        element.style.display = 'none';
    });

    var btnSubmitElements = document.querySelectorAll('#' + formId + ' .btnSubmit');
    btnSubmitElements.forEach(function(element) {
        element.style.display = 'block';
    });
}

function resetForm(formId) {
    // Get the form by its ID
    var form = document.getElementById(formId);

    // Reset all textarea fields
    var textareas = form.querySelectorAll('textarea');
    textareas.forEach(function(textarea) {
        textarea.value = '';
    });

    // Reset all input fields except buttons, submit, reset, hidden, checkboxes, and radios
    var inputs = form.querySelectorAll('input');
    inputs.forEach(function(input) {
        var type = input.type;
        if (type !== 'button' && type !== 'submit' && type !== 'reset' && type !== 'hidden' && type !== 'checkbox' && type !== 'radio') {
            input.value = '';
        } else if (type === 'checkbox' || type === 'radio') {
            input.checked = false;
        }
    });

    // Reset all select fields
    var selects = form.querySelectorAll('select');
    selects.forEach(function(select) {
        select.selectedIndex = -1; // Deselect all options
    });

    // Call the clearErrors function to remove any error messages
    clearErrors(formId);
}




